import moment from 'moment';
import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createUserFailed, createUserSuccessful } from '../actions';
import { CREATED } from '../../../configs/serverStatusCodes';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

const hasFiles = data => Boolean(
  (typeof File !== 'undefined' && data.entry_image_file instanceof File)
  || (typeof File !== 'undefined' && data.exit_image_file instanceof File),
);

const appendFormData = (formData, key, value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return;
  }

  if (typeof File !== 'undefined' && value instanceof File) {
    formData.append(key, value, value.name);
    return;
  }

  formData.append(key, value);
};

const toRequestPayload = userData => {
  const issueAt = userData.issue_at && moment(userData.issue_at).isValid()
    ? moment(userData.issue_at).toISOString()
    : null;
  const expiryAt = userData.expiry_at && moment(userData.expiry_at).isValid()
    ? moment(userData.expiry_at).toISOString()
    : null;

  const payload = {
    ...userData,
    issue_at: issueAt,
    expiry_at: expiryAt,
  };

  if (!hasFiles(payload)) {
    return { body: payload, noStringify: false };
  }

  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => appendFormData(formData, key, value));

  return { body: formData, noStringify: true };
};

export default function* createUser(action) {
  try {
    const {
      userData = {},
    } = action.payload;
    const url = `${BACKEND_URL}/clients`;
    const { body, noStringify } = toRequestPayload(userData);
    const dataResponse = yield makeRequest(url, body, action, 'POST', true, {}, noStringify);
    const data = yield getBodyJson(dataResponse, {});

    if (dataResponse.status === CREATED && data) {
      yield put(createUserSuccessful([]));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(createUserFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createUserFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
